__turbopack_context__.v({
  "className": "notosanstc_1e612846-module__FAva7a__className",
  "variable": "notosanstc_1e612846-module__FAva7a__variable",
});
